import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap'
import './assets/main.min.css';

// Import Bootstrap CSS (if you're using Bootstrap's main CSS)
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle';

// Import Bootstrap Icons CSS
import 'bootstrap-icons/font/bootstrap-icons.css';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

const app = createApp(App)

app.component('VueDatePicker', VueDatePicker);
app.component('v-select', vSelect);
app.use(store)
app.use(router)
app.use(VueSweetalert2)
app.mount('#app')

// Before mounting the app, attempt to fetch the user
// This ensures your auth state is determined on page load
// store.dispatch('fetchUser').then(() => {
//     app.mount('#app');
// });